import { useContext } from "react";
import { UserRoleContext } from "@/contexts/user-role-context-type";

export function useUserRole() {
  const context = useContext(UserRoleContext);
  if (!context) {
    throw new Error("useUserRole must be used within UserRoleProvider");
  }
  return context;
}

